"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveBar = void 0;
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const slicing_svg_1 = __importDefault(require("./slicing.svg"));
const useStyles = (0, makeStyles_1.default)({
    activeBar: {
        width: ({ progress }) => `${progress}%`,
        background: ({ background }) => background,
        height: '100%',
        position: 'absolute',
        bottom: 0,
        borderRadius: 0
    },
    currentPoint: {
        width: '3px',
        height: 'calc(100% + 4px)',
        position: 'absolute',
        top: '-2px',
        right: '-1.5px',
        borderRadius: 0,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
        backgroundColor: 'black',
        zIndex: 12
    },
    actionButton: {
        position: 'absolute',
        top: 'calc(100% + 8px)',
        right: '-0.75rem',
        background: '#090c10',
        borderRadius: '50%',
        zIndex: 1
    },
    changeTimeIcon: {
        color: 'white',
        cursor: 'pointer'
    }
});
const ActiveBar = ({ showSlice, showEnd, progress = 0, // percent of current slice
background, onSlice }) => {
    const classes = useStyles({ progress, background });
    return (react_1.default.createElement(Box_1.default, { className: classes.activeBar }, showEnd && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Box_1.default, { className: classes.currentPoint }),
        showSlice && (react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "center", alignItems: "center", className: classes.actionButton },
            react_1.default.createElement(Tooltip_1.default, { title: "Split" },
                react_1.default.createElement(IconButton_1.default, { size: "small", onClick: onSlice },
                    react_1.default.createElement("img", { style: {
                            width: '16px',
                            height: '16px',
                            padding: '3px'
                        }, src: slicing_svg_1.default, alt: "slice", draggable: false })))))))));
};
exports.ActiveBar = ActiveBar;
//# sourceMappingURL=active-bar.js.map